import { InlinePopupProps } from "csi/middleware/inline/InlinePopup";
import { TextField } from "designSystem/index";
import { stopMuiEvent } from "designSystem/utilities/prevent-default-behavior";
import React, { FunctionComponent, KeyboardEventHandler, SyntheticEvent, useRef, useState } from "react";

const InlineTextField: FunctionComponent<InlinePopupProps> = (props) => {
	const { onCancel, onChange, onLastInputChange, placeholderOptions } = props;
	const [errorState, setErrorState] = useState(false);

	const newValueRef = useRef(placeholderOptions.value);
	let newValue = newValueRef.current;

	// this event happen on every value change: remember new value and use callback to remember input change
	const onChangeValue = (ev: React.ChangeEvent<HTMLInputElement>): void => {
		newValue = newValueRef.current = ev.target.value;
		onLastInputChange(newValue);
	};

	const acceptAndClose = (ev: SyntheticEvent): void => {
		onChange(ev, newValue);
		// if validation will fail - user will see error state (changed border color), otherwise control will be removed
		// timeout is required to prevent immediate rerender which would make error colors visible even if there are no error
		setTimeout(()=>setErrorState(true), 750);
	};

	// process Tab, Enter
	const onTabOrEnter: KeyboardEventHandler = (ev) => {
		stopMuiEvent(ev);
		acceptAndClose(ev);
	};
	// process Escape
	const onEscape: KeyboardEventHandler = (ev) => {
		stopMuiEvent(ev);
		onCancel();
	};
	
	return (
		<TextField
			autoComplete="off"
			autoFocus
			defaultValue={placeholderOptions.value}
			error={errorState}
			fullWidth
			id="csi-automation-inline-textfield"
			onBlur={acceptAndClose}
			onChange={onChangeValue}
			onEnter={onTabOrEnter}
			onEscape={onEscape}
			onTab={onTabOrEnter}
			selectOnFocus
		/>
	);
};

export default InlineTextField;
